import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Button from 'react-bootstrap/Button'
import Page from '../../component/page'
import CourseMap from './CourseMap'
import CourseHeader from './CourseHeader'
import CourseDetails from './CourseDetails'
import Scorecard from './Scorecard'
import CourseHoles from './CourseHoles'
import { nameById as nameCountryById } from '../../js/countries'
import { nameById as nameStateById } from '../../js/states'

const loadCourse = (id) => ({
  type: 'LOAD_COURSE',
  payload: {
    request: {
      url: `/v3/layout/${id}`,
    },
  },
})

const loadCourseGroup = (id) => ({
  type: 'LOAD_COURSE_GROUP',
  id,
  payload: {
    request: {
      url: `/v3/course/${id}/layouts`,
    },
  },
})

// tee/basket/pos are stored as integer microdegrees; convert to decimal degrees for the map.
const microToLatLng = (location) =>
  location
    ? { lat: location.lat * 0.000001, lng: location.lng * 0.000001 }
    : null

function Course(props) {
  const params = useParams()
  const dispatch = useDispatch()

  const course = props.course.data
  const { id: groupId, courseId } = params
  console.log('Course params', params)

  const loadCourseData = (courseId) => {
    console.log('loadCourseData', courseId)
    if (course === null || course.id !== courseId) {
      dispatch(loadCourse(courseId))
      dispatch(loadCourseGroup(courseId))
    }
  }

  useEffect(() => {
    loadCourseData(courseId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId])

  if (course) {
    console.log('Course details', course)

    // The group id segment may be missing/"undefined" (e.g. when arriving from the Rounds
    // list before the fix); fall back to the group id carried by the loaded layout so the
    // header link and community metadata still work without an extra API call.
    const resolvedGroupId =
      groupId && groupId !== 'undefined' ? groupId : course.groupId

    // Prefer the course (group) name/location when the group list is loaded, otherwise fall back
    // to this layout's own values so a deep link still renders a useful header.
    const group = props.groups.find((g) => g.id == resolvedGroupId) // eslint-disable-line eqeqeq
    const name = (group && group.name) || course.name
    const location = (group && group.location) || microToLatLng(course.pos)
    const locationLabel =
      course.country === 236
        ? nameStateById(course.state)
        : nameCountryById(course.country)

    return (
      <Page className="container course">
        <div className="row">
          <div className="col-12">
            <CourseHeader
              name={name}
              groupId={resolvedGroupId}
              to={resolvedGroupId != null ? `/course/${resolvedGroupId}` : null}
              location={location}
              locationLabel={locationLabel}
              directions={course.i2}
            />

            <h2>{course.name}</h2>
            <CourseMap course={course} />
            <CourseDetails course={course} />

            <h2>Hole details</h2>
            <CourseHoles course={course} />

            <h2>
              Scorecard
              <a
                className="float-right"
                href={`/course/${resolvedGroupId}/${course.id}/print`}
                rel="noreferrer"
                target="_blank"
              >
                <Button variant="primary">Print</Button>
              </a>
            </h2>
            <Scorecard course={course} />
          </div>
        </div>
      </Page>
    )
  }

  return (
    <Page className="container">
      <div className="row">
        <div className="col-12">
          <h1>Loading course...</h1>
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => {
  return {
    course: state.course,
    groups: state.groups.data,
  }
}

export default connect(mapStateToProps)(Course)
